import * as React from "react";

import "./Loading.css";

export default function Loading() {
  return <h3>Loading...</h3>;
}
